<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2023-09-08 10:46:28
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-12-25 14:29:39
 * @FilePath: /wemeet-admin-new/src/views/brand/components/setSort.vue
 * @Description: 
 * Copyright (c) 2023 by WeMeet, All Rights Reserved. 
-->
<template>
  <el-drawer
    ref="drawerRef"
    v-model="dialogFormVisible"
    :before-close="handleClose"
    custom-class="demo-drawer userInfoDrawer"
    :direction="direction"
    :size="size"
    :title="title"
  >
    <el-form :model="form">
      <el-form-item label="排序值">
        <el-input v-model="form.sort" type="number" />
        <el-alert
          :closable="false"
          description="注：排序值越大，排序越靠前"
          style="margin-top: 20px; height: 50px"
          type="info"
        />
      </el-form-item>
    </el-form>
    <div class="demo-drawer__footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleSave">提交</el-button>
    </div>
  </el-drawer>
</template>
<script>
  import { defineComponent, getCurrentInstance, onMounted, reactive, ref, toRefs } from 'vue'
  import { parseTime } from '@/utils/index'
  import { setSort } from '@/api/enterPriseApi'
  export default defineComponent({
    name: 'EnterpriseListEdit',
    props: {
      meetingCode: {
        type: String,
        default: '',
      },
    },
    setup(props, { emit }) {
      const { proxy } = getCurrentInstance()
      const state = reactive({
        dialogFormVisible: false,
        direction: 'rtl',
        size: '30%',
        title: '',
        form: {
          name: '',
        },
        rules: {
          name: [{ required: true, trigger: 'blur', message: '请输入角色名称' }],
        },
        checkUserList: [],
      })
      // 打开
      const handleOpen = async (row) => {
        state.form = Object.assign({}, row)
        state.title = '设置类目分组'
        state.dialogFormVisible = true
      }
      // 关闭
      const handleClose = () => {
        state.form = {}
        state.dialogFormVisible = false
      }

      const handleDate = (val) => {
        return parseTime(val)
      }

      const handleSave = async () => {
        try {
          state.form.meetingEnterpriseId = state.form.id
          await setSort(state.form)
          proxy.$baseMessage('设置成功', 'success', 'vab-hey-message-success')
          handleClose()
          emit('fetch-data')
        } catch (e) {}
      }

      const handleSizeChange = (val) => {
        state.queryForm.pageSize = val
        fetchData()
      }
      const handleCurrentChange = (val) => {
        state.queryForm.pageNum = val
        fetchData()
      }

      const handleSelectionChange = (e) => {
        console.log(e)
        state.checkUserList = e
      }
      return {
        ...toRefs(state),
        handleOpen,
        handleClose,
        handleDate,
        handleSizeChange,
        handleCurrentChange,
        handleSelectionChange,
        handleSave,
      }
    },
  })
</script>

<style lang="scss" scoped>
  .vab-tree-border {
    height: 200px;
    padding: $base-padding;
    overflow-y: auto;
    border: 1px solid #dcdfe6;
    border-radius: $base-border-radius;
  }

  .demo-drawer__content {
    height: 85vh;
    overflow: auto;
  }
  .containerForm {
    height: 85vh;
    overflow-y: auto;
  }
  .demo-drawer__footer {
    position: fixed;
    right: 20px;
    bottom: 10px;
  }
  .margin-top {
    margin-top: 20px;
  }
</style>
